import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination, A11y, Autoplay } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "swiper/css/scrollbar";
import "swiper/css/autoplay";
import "./style.css";
import CarouselItem from "../CarouselItem";
import client from "../../utils/client";
import { useEffect, useState } from "react";
import { Skeleton } from "@chakra-ui/react";
import { Link } from "react-router-dom";

// Helper para parsear datas comuns do backend
const parseEndDate = (str) => {
  if (!str) return null;

  // ISO: 2025-08-31 ou 2025-08-31T...
  const iso = /^\d{4}-\d{2}-\d{2}/;
  // BR: 31/08/2025
  const br = /^\d{2}\/\d{2}\/\d{4}$/;

  try {
    if (iso.test(str)) {
      // Considera o fim do dia no fuso -03:00 para incluir o dia inteiro
      return new Date(str.split("T")[0] + "T23:59:59-03:00");
    }
    if (br.test(str)) {
      const [dd, mm, yyyy] = str.split("/");
      return new Date(`${yyyy}-${mm}-${dd}T23:59:59-03:00`);
    }
    const d = new Date(str);
    return isNaN(d) ? null : d;
  } catch {
    return null;
  }
};

const isActiveString = (value) =>
  typeof value === "string" && value.trim().toLowerCase() === "ativo";

const isSponsorVisible = (sponsor, now) => {
  if (!isActiveString(sponsor?.isActive)) return false;
  const end = parseEndDate(sponsor?.endDate);
  if (!end) return false; // sem data válida, não mostra
  return end.getTime() >= now.getTime(); // inclui o dia final
};

const SponsorCarousel = ({ type }) => {
  const [sponsors, setSponsors] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    let mounted = true;

    (async () => {
      setIsLoading(true);
      try {
        const response = await client.get("/sponsors");
        const items = response?.data?.sponsorItems ?? [];
        const now = new Date();

        const filtered = items
          .filter((s) => s?.type === type)
          .filter((s) => isSponsorVisible(s, now));

        if (mounted) setSponsors(filtered);
      } catch (error) {
        console.error(error);
        if (mounted) setSponsors([]);
      } finally {
        if (mounted) setIsLoading(false);
      }
    })();

    return () => {
      mounted = false;
    };
  }, [type]);

  return (
    <Skeleton isLoaded={!isLoading}>
      <Swiper
        modules={[Pagination, A11y, Autoplay]}
        spaceBetween={0}
        slidesPerView={1}
        pagination={{ clickable: true }}
        autoHeight={false}
        loop={true}
        autoplay={{
          delay: 4000,
          disableOnInteraction: true,
          reverseDirection: false,
        }}
        className="swiper-slide-image"
      >
        {sponsors.map((el) => (
          <SwiperSlide key={el.sponsorId} className="swiper-slide-image">
            <Link to={el.targetUrl} target="_blank" rel="noopener noreferrer">
              <CarouselItem
                noBlackImage={true}
                imageUrl={`${
                  process.env.REACT_APP_S3_BASEURL
                }/sponsors_images/${el?.images?.[0] ?? ""}`}
                imageFit={true}
              />
            </Link>
          </SwiperSlide>
        ))}
      </Swiper>
    </Skeleton>
  );
};

export default SponsorCarousel;
